import React, { useState, useEffect } from "react";
import "./CategoryGrid.css";
import { Link } from "react-router-dom";
import { getCategories } from "../../../api/storefront";
import { API_BASE } from "../../../api/client";
import insta1 from "../../../Assets/Instagram/insta1.jpg";

const fallbackCategories = [{ label: "New", countLabel: "0 outfits", img: insta1 }];

function shuffleArray(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const DISPLAY_COUNT = 6;

const CategoryGrid = () => {
  const [categories, setCategories] = useState(fallbackCategories);

  useEffect(() => {
    getCategories().then((list) => {
      if (list && list.length > 0) {
        const mapped = list.map((c) => {
          const url = c.image_url && typeof c.image_url === "string" ? c.image_url.trim() : "";
          const img = url ? (url.startsWith("http") ? url : API_BASE + url) : insta1;
          const n = Number(c.product_count) || 0;
          return {
            label: c.name,
            countLabel: n === 1 ? "1 outfit" : `${n} outfits`,
            img,
            id: c.id,
          };
        });
        const shuffled = shuffleArray(mapped);
        setCategories(shuffled.slice(0, DISPLAY_COUNT));
      }
    });
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="categoryGrid" aria-labelledby="category-grid-heading">
      <div className="categoryGridHeader">
        <h2 id="category-grid-heading" className="categoryGridTitle">
          Shop by category
        </h2>
        <p className="categoryGridSubtitle">Browse rentals by style — tap a category to explore.</p>
      </div>
      <div className="categoryGridInner">
        {categories.map((cat) => (
          <Link
            key={cat.id || cat.label}
            to={cat.id ? `/shop?categoryId=${cat.id}` : "/shop"}
            className="categoryGridBlock"
            onClick={scrollToTop}
            aria-label={`${cat.label}: ${cat.countLabel}`}
          >
            <div className="categoryGridMedia">
              <img src={cat.img} alt="" loading="lazy" decoding="async" />
              <div className="categoryGridScrim" aria-hidden />
            </div>
            <div className="categoryGridOverlay">
              <span className="categoryGridEyebrow">Rent</span>
              <h3 className="categoryGridName">{cat.label}</h3>
              <p className="categoryGridMeta">{cat.countLabel}</p>
            </div>
          </Link>
        ))}
      </div>
      <div className="categoryGridFooter">
        <Link to="/shop" className="categoryGridViewMore" onClick={scrollToTop}>
          View all categories
        </Link>
      </div>
    </section>
  );
};

export default CategoryGrid;
